import { PageAttr } from "../../../../shared/domain/entities/fetch-entities";
import { useConcatPages } from "../../../../shared/infrastructure";
import { useFetch } from "../../../../public/auth/infrastructure/store/fetch-context";
import { OfferSourceT, UseGetOfferSourcesFilters } from "../../domain";
import {
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  useInfiniteQuery,
} from "@tanstack/react-query";

const offerSourcesKeys = {
  all: ["offer-sources"] as const,
  offerSources: () => [...offerSourcesKeys.all, "offer-sources-list"] as const,
  offerSourcesList: (filters: UseGetOfferSourcesFilters) =>
    [...offerSourcesKeys.offerSources(), filters] as const,
};

const LOCATIONS_ENDPOINT = "approvals/offer-sources";

const useInfiniteGetOfferSources = (
  filters: UseGetOfferSourcesFilters,
  config: UseInfiniteQueryOptions<PageAttr<OfferSourceT>> = {}
): UseInfiniteQueryResult<PageAttr<OfferSourceT>> & {
  allPages: PageAttr<OfferSourceT>["data"];
} => {
  const fetch = useFetch();

  const response = useInfiniteQuery<PageAttr<OfferSourceT>>(
    offerSourcesKeys.offerSourcesList(filters),
    async ({ pageParam: page = 1 }: { pageParam?: number }) => {
      const response = await fetch.get<PageAttr<OfferSourceT>>(
        LOCATIONS_ENDPOINT,
        {
          params: {
            page,
            limit: 10,
            ...filters,
          },
        }
      );

      return response.data;
    },
    {
      ...config,
      getNextPageParam: (lastPage, allPages) =>
        lastPage.data.length > 0 ? allPages.length + 1 : undefined,
    }
  );

  const allPages = useConcatPages(response.data?.pages ?? []);

  return {
    ...response,
    allPages,
  };
};

export { offerSourcesKeys, useInfiniteGetOfferSources };
